/* eslint-disable */
import { StyleSheet ,Platform,Dimensions} from 'react-native'

export default StyleSheet.create({
  container: {
   
  
  },
  modal: {
   
    height:  Dimensions.get('window').height -  200,
    width: Dimensions.get('window').width - 20,
    borderRadius: Platform.OS === 'ios' ? 10 : 0,
    overflow: "hidden",
  },
  header : {
    padding: 10,
  
     backgroundColor: `#FFFFFF`,
     flexDirection: `row`,
     justifyContent: `space-between`,
     alignItems: `center`
  },
  button : {
    backgroundColor: `#FFFFFF`
  },
  middleText : {
    color: 'black'
  },
  textButton : {
    color : 'rgba(137,165,242,1)'
  },
  reason : {
    borderTopWidth  : 1,
    borderBottomWidth : 1,
    borderColor: `black`,
    alignItems: `center`,
    height: 44,
    width:` 100%`,
    justifyContent: `center`
  },
  textInputStyle: {
    margin: 5,
    flex: 1,

    borderColor: `transparent`,
    borderWidth : 0,
 
  },
  commentBox : {
   flex: 1,
  
  }
})
